module.exports = __webpack_public_path__ + "static/img/user_register.68eafdfc.png";